export { default as imageUrl } from "./image.png";
